/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { CompanyRegistrationResourceService, TermsAndConditionsResourceService } from '@well/resource-services';
import { Observable } from 'rxjs';
import { JsonApiResource } from '@irian-ro/abstract-resource';
import { CompanyDetailsDtoModel, TermsAndConditionsDtoModel, TermsAndConditionsTypeEnum } from '@well/domain';
import { LegalEntityModel } from '@well/common-libs/legal-entity-management/domain-model';

@Injectable({
  providedIn: 'root',
})
export class TermsAndConditionsService {
  constructor(
    private termsAndConditionsResourceService: TermsAndConditionsResourceService,
    private companyRegistrationResourceService: CompanyRegistrationResourceService
  ) {}

  getTermsAndConditions(
    documentType: TermsAndConditionsTypeEnum
  ): Observable<JsonApiResource<TermsAndConditionsDtoModel, null>> {
    return this.termsAndConditionsResourceService.findByDocumentTypeAndLastVersion(documentType);
  }

  getUnacceptedLatestForUserOrEmail(userUuid: string, documentType: TermsAndConditionsTypeEnum) {
    return this.termsAndConditionsResourceService.getUnacceptedLatestForUserOrEmail(userUuid, documentType);
  }

  getMyCompanyProfile(): Observable<JsonApiResource<CompanyDetailsDtoModel, unknown>> {
    return this.companyRegistrationResourceService.getMyCompanyProfile();
  }

  updateValidCompanyDetails(companyDetails: CompanyDetailsDtoModel): Observable<LegalEntityModel> {
    return this.companyRegistrationResourceService.updateValidCompanyDetails(companyDetails);
  }
}
